<template lang="pug">
    div(id="waypointsearch")
        keep-alive
            v-autocomplete(v-model="from_autocomplete_done" 
                            :search-input.sync="from_autocomplete" 
                            :items="search_from_results"
                            cahe-items
                            hide-no-data
                            :loading="requesting || waypoint.updating"
                            :filter="v => v",
                            :label="label"
                            hint="Type to search")
                    template(v-slot:append)
                        v-progress-circular(v-if="location_pending" size=24 color="info" indeterminate)
                        v-btn(v-else @click="getCurrentLocation" text icon color="indigo")
                            v-icon place
</template>


<script>
import { app_mgr } from './../js/app_state'
import { Waypoint } from './../js/waypoint'
import { APIGeocode, GeocodeService } from './../js/api_geocode'

var _ = require('lodash');
export default {
    props: {
        waypoint: Waypoint,
        label: String,
    },

    data: () => ({
        from_autocomplete: "",
        search_from_results: [],
        location_name: "",
        location_pending: false,
        location_ok: false,
        current_res: [],
        current_pos: [],
        editing_wp: false,
        requesting: false,
    }),

    mounted() {
        let m_waypoint = app_mgr.getWaypoint(this.waypoint.id);
        m_waypoint.addListener(() => { this.onChangedWaypoint(); })
    },

    created() {
        this.debouncedFetchPositions = _.debounce(this.fetchPositions, 250);
        this.debouncedSetNewLocation = _.debounce(this.findLocation, 500);
    },

    computed: {
         from_autocomplete_done: {
            get() {               
                return this.location_name;
            },

            set(new_value) {
                if (new_value != "") {
                    this.setPosition(new_value);
                }    
            }
        }
    },

     watch: {
        from_autocomplete(new_pos, old_pos) {
            if (new_pos != old_pos 
                && new_pos != "" 
                && new_pos != null
                && new_pos != this.location_name) {
                this.debouncedFetchPositions(new_pos);
            }
        },
    },

    methods: {
        onChangedWaypoint() {
            if (this.editing_wp) {
                this.editing_wp = false;
                return;
            }
            this.debouncedSetNewLocation();
        },

        findLocation() {
            const from = this.waypoint;

            if (!from.isValid()) {
                return "";
            }

            this.location_name = from.name;
            this.search_from_results = [this.location_name];
            this.from_autocomplete = this.location_name;
            this.$emit('waypointLocationChanged')
        },

        fetchPositions(new_pos) {
            if (new_pos === "") {
                // eslint-disable-next-line
                console.error("Should not be here, \"new_pos\" shoud be empty string");
                return;
            }
            let vm = this;

            function get_geocode() {
                vm.requesting = true;
                APIGeocode.geocode(new_pos, vm.current_pos[0], vm.current_pos[1], GeocodeService.ORS)
                    .then( res => {
                        vm.requesting = false;
                        vm.current_res = res.current_res;
                        vm.search_from_results.splice(0);  // clear array
                        for (const feature of res.search_from_results) {
                            vm.search_from_results.push(feature);
                        }
                     })
                    .catch(() => {vm.requesting = false;});    
            }

            function geo_success(position) {
                vm.current_pos[0] = position.coords.latitude;
                vm.current_pos[1] = position.coords.longitude;                               
                get_geocode();         
            }

            function geo_error() {
                vm.current_pos[0] = null;
                vm.current_pos[1] = null;                               
                get_geocode(); 
            }

            const geo_options = {
                enableHighAccuracy: true, 
                timeout           : 2000
            };

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(geo_success , geo_error, geo_options);
            } else geo_error();
        },

        setPosition(pos) {
            for(let feat of this.current_res) {
                if (pos === feat.properties.label) {
                    this.editing_wp = true;
                    this.location_name = pos;
                    app_mgr.setWaypointValues(  this.waypoint.id,
                                                feat.geometry.coordinates[0],
                                                feat.geometry.coordinates[1],
                                                this.location_name);
                    break;
                }
            }
        },

        getCurrentLocation() {
            let vm = this;
            function geo_success(position) {
                vm.location_pending = false;
                vm.location_ok = true;
                app_mgr.setWaypointValues(vm.waypoint.id, 
                                            position.coords.longitude,
                                            position.coords.latitude);
            }

            function geo_error() {
                vm.location_pending = false;
                vm.location_ok = false;
                alert("Sorry, can't get current localization.");
            }

            const geo_options = {
                enableHighAccuracy: true, 
                timeout           : 27000
            };

            navigator.geolocation.getCurrentPosition(geo_success, geo_error, geo_options);
            this.location_pending = true;
            this.location_ok = false;
        },
    },
}
</script>


<!--
taken from this: https://github.com/vuetifyjs/vuetify/issues/12106
follow up here: https://github.com/vuetifyjs/vuetify/issues/4059
-->
<style>
.v-autocomplete__content {
  max-height: 46vh !important;
}
</style>
